import { addDays, addWeeks } from 'date-fns';
import type { TimeSlot } from '../types/availability';

export const generateRecurringSlots = (
  baseSlot: Omit<TimeSlot, 'id'>,
  pattern: 'daily' | 'weekly' | null,
): Omit<TimeSlot, 'id'>[] => {
  const slots: Omit<TimeSlot, 'id'>[] = [];
  // End date is 30 days from the first slot's date, not from now
  const endDate = addDays(new Date(baseSlot.startTime), 30);
  let currentDate = new Date(baseSlot.startTime);

  while (currentDate <= endDate) {
    const slotStart = new Date(currentDate);
    const slotEnd = new Date(
      slotStart.getTime() + baseSlot.duration * 60000
    );

    // Check for self-overlap: ensure this slot doesn't overlap the previous one
    if (slots.length > 0) {
      const prevSlot = slots[slots.length - 1];
      if (slotStart < prevSlot.endTime) {
        throw new Error(
          `Recurring slots overlap each other: a ${baseSlot.duration}-minute slot repeated ${pattern} causes overlaps. Reduce the duration or change the pattern.`
        );
      }
    }

    slots.push({
      ...baseSlot,
      startTime: slotStart,
      endTime: slotEnd,
    });

    currentDate = pattern === 'daily'
      ? addDays(currentDate, 1)
      : addWeeks(currentDate, 1);
  }

  return slots;
};
